///salesorder/create
export const CREATE_SALES_ORDER = "CREATE_SALES_ORDER";
export const CREATE_SALES_ORDER_SUCCESS = "CREATE_SALES_ORDER_SUCCESS";
export const CREATE_SALES_ORDER_FAILURE = "CREATE_SALES_ORDER_FAILURE";
///extpostcodelookup/search
export const POSTCODE_LOOKUP = "POSTCODE_LOOKUP";
export const POSTCODE_LOOKUP_SUCCESS = "POSTCODE_LOOKUP_SUCCESS";
export const POSTCODE_LOOKUP_FAILURE = "POSTCODE_LOOKUP_FAILURE";
///ecommercestore/render/
export const GET_RENDER_ECOMMERCE_STORE = "GET_RENDER_ECOMMERCE_STORE";
export const GET_RENDER_ECOMMERCE_STORE_SUCCESS =
  "GET_RENDER_ECOMMERCE_STORE_SUCCESS";
export const GET_RENDER_ECOMMERCE_STORE_FAILURE =
  "GET_RENDER_ECOMMERCE_STORE_FAILURE";
///ecommercestoreproductcategory/public/listwithproduct/
export const GET_PRODUCT_CATEGORIES = "GET_PRODUCT_CATEGORIES";
export const GET_PRODUCT_CATEGORIES_SUCCESS = "GET_PRODUCT_CATEGORIES_SUCCESS";
export const GET_PRODUCT_CATEGORIES_FAILURE = "GET_PRODUCT_CATEGORIES_FAILURE";
///ecommercestoreproductcategorytoproduct/public/search/
export const SEARCH_PRODUCTS_CATEGORY = "SEARCH_PRODUCTS_CATEGORY";
export const SEARCH_PRODUCTS_CATEGORY_SUCCESS =
  "SEARCH_PRODUCTS_CATEGORY_SUCCESS";
export const SEARCH_PRODUCTS_CATEGORY_FAILURE =
  "SEARCH_PRODUCTS_CATEGORY_FAILURE";
///ecommercestore/public/calculate/shipping/
export const CALCULATE_SHIPPING = "CALCULATE_SHIPPING";
export const CALCULATE_SHIPPING_SUCCESS = "CALCULATE_SHIPPING_SUCCESS";
export const CALCULATE_SHIPPING_FAILURE = "CALCULATE_SHIPPING_FAILURE";
///ecommercestore/public/calculate/ordertotal/
export const CALCULATE_ORDER_TOTAL = "CALCULATE_ORDER_TOTAL";
export const CALCULATE_ORDER_TOTAL_SUCCESS = "CALCULATE_ORDER_TOTAL_SUCCESS";
export const CALCULATE_ORDER_TOTAL_FAILURE = "CALCULATE_ORDER_TOTAL_FAILURE";
///ecommercestore/public/execute/
export const EXECUTE_ECOMMERCE_STORE = "EXECUTE_ECOMMERCE_STORE";
export const EXECUTE_ECOMMERCE_STORE_SUCCESS =
  "EXECUTE_ECOMMERCE_STORE_SUCCESS";
export const EXECUTE_ECOMMERCE_STORE_FAILURE =
  "EXECUTE_ECOMMERCE_STORE_FAILURE";
///ecommercestoredeliveryslot/public/list/
export const GET_ECOMMERCE_DELIVERY_SLOTS = "GET_ECOMMERCE_DELIVERY_SLOTS";
export const GET_ECOMMERCE_DELIVERY_SLOTS_SUCCESS =
  "GET_ECOMMERCE_DELIVERY_SLOTS_SUCCESS";
export const GET_ECOMMERCE_DELIVERY_SLOTS_FAILURE =
  "GET_ECOMMERCE_DELIVERY_SLOTS_FAILURE";
